import React from 'react';

function MError({ text }) {
    return (
        <div className={'m-1'}>
            <span
                 className={`text-red-500`}
            >
                {text || 'Ошибка'}
            </span>
        </div>
    );
}

export default MError;
